import React, { useEffect, useState } from "react";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../API/api";
import moment from "moment";
import { toast } from "sonner";
import colors from "../../assets/theme/base/colors";
import NDFImage from "../../assets/images/no-data.jpg";
import NoImage from "../../assets/images/Image-not-found.png";
import AddDeviceModal from "components/Modals/AddDeviceModal/AddDeviceModal";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AddScenarioModal from "components/Modals/AddScenarioModal/AddScenarioModal";
import DeleteDeviceModal from "components/Modals/DeleteDeviceModal/DeleteDeviceModal";
import DeleteScenarioModal from "components/Modals/DeleteScenarioModal/DeleteScenarioModal";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const Scenarios = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [siteName, setSiteName] = useState("");
  const { white, gradients } = colors;
  const [sitesData, setSitesData] = useState([]);
  const [editDeviceData, setEditDeviceData] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [addScenarioOpen, setAddScenarioOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const [editScenarioData, setEditScenarioData] = useState(null);
  const [selectedScenario, setSelectedScenario] = useState(null);
  const [addDeviceOpen, setAddDeviceOpen] = useState(false);
  const [sitesServiceData, setServiceSitesData] = useState([]);
  const [scenarioLoading, setScenarioLoading] = useState(false);
  const [deleteDeviceOpen, setDeleteDeviceOpen] = useState(false);
  const [deleteScenarioOpen, setDeleteScenarioOpen] = useState(false);

  const handleEditDevice = (video) => {
    setEditDeviceData(video);
    setAddDeviceOpen(true);
  };

  const handleEditScenario = (scenario) => {
    setEditScenarioData(scenario);
    setAddScenarioOpen(true);
  };

  const handleDeleteDeviceClick = (device) => {
    setSelectedDevice(device);
    setDeleteDeviceOpen(true);
  };

  const handleDeleteScenarioClick = (scenario) => {
    setSelectedScenario(scenario);
    setDeleteScenarioOpen(true);
  };

  const handleScenarioClick = (scenario) => {
    const associatedDevice = sitesData?.find(
      (device) => device?.device_id === scenario?.device_id
    );

    navigate(`/scenarios-detail/${scenario?.service_id}`, {
      state: {
        scenario,
        device: associatedDevice,
        admin_site_id: id,
        scenario_id: scenario?.service_id,
      },
    });
  };

  const getSitesList = async () => {
    try {
      setScenarioLoading(true);
      const response = await api.get(`/cv/site-details/${id}/`);
      setSitesData(response?.data?.data?.data?.devices);
      setServiceSitesData(response?.data?.data?.data?.services);
      const site = `${response?.data?.data?.site_name} (${response?.data?.data?.location})`;
      setSiteName(site);
    } catch (error) {
      toast.error(error?.response?.data?.detail);
    } finally {
      setScenarioLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getSitesList();
    }
  }, [id]);

  for (let i = 0; i < sitesServiceData.length; i++) {
    localStorage.removeItem(
      `${sitesServiceData[i]?.service_id}_detectionStatus`
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box>
        {!scenarioLoading && sitesData && (
          <Typography mb={2}>
            {siteName?.split(" (")[0]}
            <span style={{ fontSize: "16px", color: "gray" }}>
              {" "}
              ({siteName?.split(" (")[1]}
            </span>
          </Typography>
        )}
        <Accordion
          defaultExpanded={true}
          sx={{
            mb: 2,
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            borderRadius: "12px !important",
            p: 1,
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                pr: 1,
              }}
            >
              <Typography
                sx={{ fontSize: "18px", color: "gray", fontWeight: "500" }}
              >
                Devices
              </Typography>
              {user?.role === "admin" && (
                <Button
                  className="add-btn"
                  variant="info"
                  onClick={() => {
                    setEditDeviceData(null);
                    setAddDeviceOpen(true);
                  }}
                  sx={{
                    height: "38px",
                    fontWeight: "500",
                    borderRadius: "6px",
                    background: `${gradients.info.main}`,
                    color: white.main,
                    "&:hover": {
                      background: `${gradients.info.state} !important`,
                      color: white.main,
                    },
                  }}
                >
                  Add Devices
                </Button>
              )}
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            {scenarioLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress
                  sx={{
                    height: "35px",
                    width: "35px",
                    color: `${gradients.info.main}`,
                  }}
                />
              </Box>
            ) : !sitesData?.length ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img src={NDFImage} alt="No Data" style={{ width: "50%" }} />
                <Typography variant="h6" color="text.disabled">
                  No Devices Found
                </Typography>
              </Box>
            ) : (
              <Grid container spacing={5} className="g-4 mt-3">
                {sitesData?.map((video, id) => (
                  <Grid item key={id} xs={12} sm={6} md={4}>
                    <div className="video-card">
                      <div
                        className="thumbnail-image"
                        style={{
                          backgroundImage: `url(${
                            video?.thumbnail || NoImage
                          })`,
                        }}
                      ></div>
                      <div className="video-details">
                        <p className="video-title text-secondary">
                          {video?.device_name}
                        </p>
                      </div>
                      {user?.role === "admin" && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "end",
                            gap: 1.5,
                          }}
                        >
                          <EditOutlinedIcon
                            title="Edit Device"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditDevice(video);
                            }}
                            sx={{
                              cursor: "pointer",
                              color: "gray",
                              height: "18px",
                            }}
                          />
                          <DeleteOutlineOutlinedIcon
                            title="Delete Device"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteDeviceClick(video);
                            }}
                            sx={{
                              color: "error.main",
                              height: "18px",
                              cursor: "pointer",
                            }}
                          />
                        </Box>
                      )}
                    </div>
                  </Grid>
                ))}
              </Grid>
            )}
          </AccordionDetails>
        </Accordion>
        {sitesData?.length > 0 && (
          <Accordion
            sx={{
              boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              borderRadius: "12px !important",
              p: 1,
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  pr: 1,
                }}
              >
                <Typography
                  sx={{ fontSize: "18px", color: "gray", fontWeight: "500" }}
                >
                  Scenarios
                </Typography>
                {user?.role === "admin" && (
                  <Button
                    className="add-btn"
                    variant="info"
                    onClick={() => {
                      setEditScenarioData(null);
                      setAddScenarioOpen(true);
                    }}
                    sx={{
                      height: "38px",
                      fontWeight: "500",
                      borderRadius: "6px",
                      background: `${gradients.info.main}`,
                      color: white.main,
                      "&:hover": {
                        background: `${gradients.info.state} !important`,
                        color: white.main,
                      },
                    }}
                  >
                    Add Scenario
                  </Button>
                )}
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              {scenarioLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress sx={{ height: "35px", width: "35px" }} />
                </Box>
              ) : (
                <Grid container spacing={2} className="g-4 mt-3">
                  {sitesServiceData?.map((scenario) => (
                    <Grid item key={scenario?.service_id} xs={12} sm={6} md={4}>
                      <div
                        className="scenario-card"
                        onClick={() => handleScenarioClick(scenario)}
                      >
                        <h5 className="card-title">
                          {scenario?.device_name
                            ? scenario.device_name.charAt(0).toUpperCase() +
                              scenario.device_name.slice(1)
                            : ""}
                        </h5>

                        <h6 className="card-sub-title">
                          {scenario?.provided_service_type}
                        </h6>
                        <p className="card-status">
                          Detect Status:{" "}
                          <span className={scenario?.status}>
                            {scenario?.status}
                          </span>
                        </p>
                        <p className="card-date">
                          <strong>Created At</strong> :{" "}
                          {moment(scenario?.created_at)
                            .local()
                            .format("DD-MM-YYYY")}
                        </p>
                        {user?.role === "admin" && (
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1.5,
                              justifyContent: "end",
                            }}
                          >
                            <EditOutlinedIcon
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEditScenario(scenario);
                              }}
                              title="Edit Scenario"
                              sx={{
                                cursor: "pointer",
                                color: "gray",
                                height: "18px",
                              }}
                            />
                            <DeleteOutlineOutlinedIcon
                              title="Delete Scenario"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteScenarioClick(scenario);
                              }}
                              sx={{
                                color: "error.main",
                                cursor: "pointer",
                                height: "18px",
                              }}
                            />
                          </Box>
                        )}
                      </div>
                    </Grid>
                  ))}
                </Grid>
              )}
            </AccordionDetails>
          </Accordion>
        )}
      </Box>
      {addDeviceOpen && (
        <AddDeviceModal
          id={id}
          sitesData={sitesData}
          editDeviceData={editDeviceData}
          addDeviceOpen={addDeviceOpen}
          setAddDeviceOpen={setAddDeviceOpen}
          getSitesList={getSitesList}
        />
      )}

      {addScenarioOpen && (
        <AddScenarioModal
          sitesData={sitesData}
          addScenarioOpen={addScenarioOpen}
          sitesServiceData={sitesServiceData}
          editScenarioData={editScenarioData}
          setAddScenarioOpen={setAddScenarioOpen}
          getSitesList={getSitesList}
        />
      )}

      {deleteScenarioOpen && (
        <DeleteScenarioModal
          deleteScenarioOpen={deleteScenarioOpen}
          setDeleteScenarioOpen={setDeleteScenarioOpen}
          selectedScenario={selectedScenario}
          getSitesList={getSitesList}
        />
      )}
      {
        <DeleteDeviceModal
          deleteDeviceOpen={deleteDeviceOpen}
          setDeleteDeviceOpen={setDeleteDeviceOpen}
          selectedDevice={selectedDevice}
          getSitesList={getSitesList}
        />
      }
    </DashboardLayout>
  );
};

export default Scenarios;
